(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-custom-video-image"] && !Shopify.designMode) return;
  try {
    
class CustomVideo extends HTMLElement {
  constructor() {
    super();
    this.section = this.querySelector('.custom-video');
    this.wrapper = this;
    if (this.section) {
      this.applyDynamicStyles();
      this.setupEventListeners();
      if (this.dataset.enableSnap === 'true') {
        this.setupScrollSnapping();
      }
    }
  }

  applyDynamicStyles() {
    const manual = parseInt(this.section.dataset.headerHeightManual || 0);
    const slider = parseInt(this.section.dataset.headerHeight || 0);
    const height = manual > 0 ? manual : slider;
    const overlaps = this.section.dataset.overlapHeader === "true";

    if (overlaps) {
      this.section.classList.add('overlap-header');
      this.section.style.zIndex = '0';
    } else {
      this.section.classList.remove('overlap-header');
      this.section.style.zIndex = '';
    }

    if (this.section.classList.contains('custom-video-full')) {
      const vh = window.innerHeight;
      this.section.style.height = `${vh}px`;
    }

    const headingEl = this.section.querySelector('.custom-video__heading');
    const subtextEl = this.section.querySelector('.custom-video__subtext');

    if (headingEl) headingEl.style.fontSize = `${this.section.dataset.headingSize}px`;
    if (subtextEl) subtextEl.style.fontSize = `${this.section.dataset.subtextSize}px`;
  }

  setupEventListeners() {
    window.addEventListener('resize', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:section:load', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:section:select', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:section:deselect', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:block:select', this.applyDynamicStyles.bind(this));
    document.addEventListener('shopify:block:deselect', this.applyDynamicStyles.bind(this));
  }

  setupScrollSnapping() {
    if (this.dataset.enableSnap !== 'true') return;

    let lastScrollTime = 0;
    const scrollCooldown = 500;

    this.wheelHandler = (e) => {
      const now = Date.now();
      if (now - lastScrollTime < scrollCooldown) {
        e.preventDefault();
        return;
      }

      const rect = this.getBoundingClientRect();
      const visibleRatio = Math.abs(rect.top) < window.innerHeight / 2;

      if (visibleRatio) {
        const direction = e.deltaY > 0 ? 1 : -1;
        const nextSection = this.findNextScrollTarget(direction);
        
        if (nextSection) {
          e.preventDefault();
          nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          lastScrollTime = now;
        }
      }
    };

    window.addEventListener('wheel', this.wheelHandler, { passive: false });
  }

  findNextScrollTarget(direction) {
    const allSections = Array.from(document.querySelectorAll('.custom-video-wrapper'));
    const currentIndex = allSections.indexOf(this);
    
    if (direction > 0) {
      // Looking for next section
      for (let i = currentIndex + 1; i < allSections.length; i++) {
        const section = allSections[i];
        if (section.dataset.enableSnap === 'true') {
          return section;
        }
      }
      // If no next snap section found, return null to allow normal scrolling
      return null;
    } else {
      // Looking for previous section
      for (let i = currentIndex - 1; i >= 0; i--) {
        const section = allSections[i];
        if (section.dataset.enableSnap === 'true') {
          return section;
        }
      }
      // If no previous snap section found, return null to allow normal scrolling
      return null;
    }
  }

  disconnectedCallback() {
    if (this.wheelHandler) {
      window.removeEventListener('wheel', this.wheelHandler);
    }
  }
}

customElements.define('custom-video-section', CustomVideo);

// Add this to handle the conditional display of the left image width setting
document.addEventListener('DOMContentLoaded', function() {
  const ratioSelect = document.querySelector('[name="side_image_ratio"]');
  const leftWidthSetting = document.querySelector('.side-image-ratio-custom');
  
  if (ratioSelect && leftWidthSetting) {
    function toggleLeftWidth() {
      if (ratioSelect.value === 'custom') {
        leftWidthSetting.style.display = 'block';
      } else {
        leftWidthSetting.style.display = 'none';
      }
    }

    // Initial state
    toggleLeftWidth();

    // Listen for changes
    ratioSelect.addEventListener('change', toggleLeftWidth);
  }
});

  } catch(e) { console.error(e); }
})();
})();
